var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "friend-links" }, [
    _c("h1", { staticClass: "title" }, [_vm._v("学茶商城合作伙伴")]),
    _c("div", { staticClass: "content" }, [
      _c("img", { attrs: { src: _vm.ncwPcJoin } }),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }